import { render } from "./viewPdf.vue?vue&type=template&id=00c2196e&scoped=true&ts=true"
import script from "./viewPdf.vue?vue&type=script&lang=tsx"
export * from "./viewPdf.vue?vue&type=script&lang=tsx"

import "./viewPdf.vue?vue&type=style&index=0&id=00c2196e&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/OfferCloud2_FrontWebs_All/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00c2196e"]])

export default __exports__